module.exports = __webpack_public_path__ + "img/ida-white.6763177b.png";